import { isMoreThan, hasDigit, hasCapitalLetter } from 'utils/validation';

export default password => (
  isMoreThan(password, 7, true)
  && hasCapitalLetter(password)
  && hasDigit(password)
);
